import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { useRouter } from '@tribeplatform/react-sdk';
import { useUpdateMember, useUploadFile } from '@tribeplatform/react-sdk/hooks';
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar';
import { SpinnerIcon } from '@tribeplatform/react-ui-kit/icons';
import { toast } from '@tribeplatform/react-ui-kit/Toast';
import { useCropImageModal } from '../../../CropImageModal';
import { T, useI18n } from '../../../i18n';
export const ProfilePicture = ({ member, className, size = '3xl', editable = true, }) => {
    var _a;
    const intl = useI18n();
    const { Link } = useRouter();
    const fileInputRef = useRef();
    const { loadingFile, uploadFile, loading: uploadFileLoading, } = useUploadFile();
    const { mutateAsync: updateMember, isLoading: updateMemberLoading } = useUpdateMember();
    const onUpload = ({ croppedImage }) => {
        uploadFile(croppedImage, async (uploadedImage) => {
            await updateMember({
                input: {
                    profilePictureId: uploadedImage.id,
                },
                id: member.id,
            }, {
                onSuccess: () => {
                    toast({
                        title: intl.$t({
                            id: 'ProfilePicture.Updated',
                            defaultMessage: 'Profile picture successfully updated',
                        }),
                        status: 'success',
                    });
                },
                onError: () => {
                    toast({
                        title: intl.$t({
                            id: 'ProfilePicture.FailedToUpdate',
                            defaultMessage: 'Something went wrong and we were unable to update your profile picture! Please try again.',
                        }),
                        status: 'error',
                    });
                },
            });
        });
    };
    const { onSelectFile, children: cropModal } = useCropImageModal({
        onSuccess: onUpload,
        options: {
            shape: 'round',
        },
    });
    const onChangeFile = (e) => {
        var _a;
        const file = (_a = Array.from(e.target.files)) === null || _a === void 0 ? void 0 : _a[0];
        // allow to select same file twice
        e.target.value = '';
        onSelectFile(file);
    };
    const avatar = loadingFile || member.profilePicture;
    const avatarMarkup = (_jsx(Avatar, { size: size, name: member.name, className: className, src: ((_a = avatar === null || avatar === void 0 ? void 0 : avatar.urls) === null || _a === void 0 ? void 0 : _a.small) || (avatar === null || avatar === void 0 ? void 0 : avatar.url) }, void 0));
    return (_jsxs("div", { children: [_jsxs("div", { className: "hover:bg-surface-hovered rounded-full relative", children: [editable ? (avatarMarkup) : (_jsx(Link, { href: member.relativeUrl, disabled: editable, children: avatarMarkup }, void 0)), editable && (_jsx("input", { type: "file", disabled: updateMemberLoading, className: "hidden", multiple: false, ref: fileInputRef, onChange: onChangeFile }, void 0)), (uploadFileLoading || updateMemberLoading) && (_jsx("div", { className: "flex items-center justify-center text-white rounded-full bg-background-backdrop absolute top-0 bottom-0 start-0 end-0", children: _jsx(SpinnerIcon, { className: "animate-spin h-7 w-7" }, void 0) }, void 0)), editable && !(uploadFileLoading || updateMemberLoading) && (_jsx("div", { onClick: () => {
                            var _a;
                            (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
                        }, className: "flex items-center justify-center rounded-full text-white bg-black bg-opacity-50 opacity-0 hover:opacity-90 absolute top-0 bottom-0 start-0 end-0 cursor-pointer", children: _jsx(T, { id: "Generics.Change.Verb", defaultMessage: "Change" }, void 0) }, void 0))] }, void 0), cropModal] }, void 0));
};
//# sourceMappingURL=ProfilePicture.js.map